import { useEffect } from "react";
import {
  TextField,
  Grid,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { IssuedCards, resetForm, setDialog } from "../../../../app/slices/issuedCardSlice";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  HiOutlineCreditCard,
  HiOutlineIdentification,
  HiOutlineCalendarDays,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const IssuedCardForm = () => {

  const _IssuedCard = useSelector((state) => state.issuedCard.issuedCard);
  const _SearchBody = useSelector((state) => state.issuedCard.searchBody);
  const loading = useSelector((state) => state.issuedCard.loading);

  const isAdd = _IssuedCard.form.id ? false : true;
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _IssuedCard.form,
  });

  const onSubmit = (data) => {
    dispatch(IssuedCards.updateStatus(data.id, {
      holder_name: data.holder_name,
      number: data.number,
      type: data.type,
      order_issued_id: data.order_issued_id,
      issued_at: data.issued_at,
      status_id: _IssuedCard.form.status_id,
    }, _SearchBody, true))

  };
  useEffect(() => {
    reset({ ..._IssuedCard.form });
  }, [_IssuedCard.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog({
      status_id: null,
      id: null
    }));
  };


  return (
    <FormDialog
      open={_IssuedCard.dialog}
      onClose={handleDialog}
      maxWidth="md"
      icon={<HiOutlineCreditCard />}
      title={isAdd ? "إضافة بطاقة" : "تعديل البطاقة"}
      subtitle={
        isAdd
          ? "أدخل معلومات البطاقة لإضافتها"
          : "قم بتحديث معلومات البطاقة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_IssuedCard.loading}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات البطاقة">
        <Grid item xs={12} sm={6}>
          <Controller
            name="holder_name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="اسم حامل البطاقة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="type"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth>
                <InputLabel>نوع البطاقة</InputLabel>
                <Select
                  value={field.value}
                  label="نوع البطاقة"
                  size="small"
                  onChange={(e, newValue) => setValue("type", newValue)}
                  {...field}
                >
                  <MenuItem value="master">Master Card</MenuItem>
                  <MenuItem value="visa">Visa Card</MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم البطاقة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineCalendarDays />} title="معلومات الاصدار">
        <Grid item xs={12} sm={6}>
          <Controller
            name="order_issued_id"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم طلب الاصدار"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="issued_at"
            control={control}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  inputFormat="YYYY-MM-DD"
                  label="التاريخ"
                  value={field.value}
                  onChange={(e, newValue) => {
                    setValue("date", dayjs(e).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      fullWidth
                      {...params}
                      inputProps={{ ...params.inputProps, placeholder: "يوم/شهر/سنة" }}
                    />
                  )}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default IssuedCardForm;
